import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

export const PopupCloseButton = styled.button`
    position: absolute;
    right: 14px;
    top: 14px;
    padding: 0;
    border: 0;
    background: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;

    &:before {
        display: block;
        content: "";
        width: 12px;
        height: 12px;
        background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZ
          pZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3Z
          nIj4KPHBhdGggZD0iTTEzIDFDNy41MzI2NiA2LjQ2NzM0IDEgMTMgMSAxM00xIDFMMTMgMTMiIHN0cm9rZT0iIzV
          DNUU2MiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9
          pbj0icm91bmQiLz4KPC9zdmc+Cg==") no-repeat;
        background-size: contain;
    }
`;

export const Wrapper = styled.div<{ isShown: boolean }>`
    display: none;

    @media (max-width: ${wideBreakpoints.laptop}) {
        display: block;
    }

    position: fixed;
    right: 0;
    bottom: 0;
    left: 0;

    z-index: ${props => props.isShown ? 201 : 199} ;

    ${PopupCloseButton} {
        height: 40px;
        width: 40px;
        background-color: ${COLORS.ButtonSecondary};
        border-radius: 40px;
        top: 32px;
        right: 16px;
        cursor: pointer;

        @media (max-width: ${wideBreakpoints.mobile}) {
            height: 28px;
            width: 28px;
        }
    }
`;

export const Overlay = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    background-color: rgba(0, 0, 0, 0.5);
    cursor: pointer;
`;

const Body = styled.div`
    position: absolute;
    bottom: 0;
    width: 100%;
    background-color: ${COLORS.BgSurface};
    border-radius: 32px 32px 0 0;
    align-items: center;
    align-content: center;
    justify-content: space-between;
    z-index: 2;
`;

export const Strip = styled.div`
    position: absolute;
    left: calc(50% - 20px);
    top: 10px;
    cursor: pointer;

    width: 40px;
    height: 4px;
    background: ${COLORS.Outline_Light};
    border-radius: 12px;
`;

export const ActionButton = styled.div`
    cursor: pointer;

    padding: 0;
    height: 28px;
    width: 28px;
    border-radius: 50%;
    background-color: ${COLORS.ButtonSecondary};
    
    position: absolute;
    top: 16px;
    right: 16px;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const FullBody = styled(Body)`
    padding: 18px 16px 16px 16px;
    
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${COLORS.Outline_Light};
`;

export const ShortBody = styled(Body)`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;

    // 52px for right indent is summarize of open button width (28px) / 8px gap from button / 16px default indent from right side
    padding: 16px 52px 16px 16px;

    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    border: 1px solid ${COLORS.Outline_Light};
`;
